export const FETCH_ASSOCIATED_PARTIES_DATA_REQUEST="FETCH_ASSOCIATED_PARTIES_DATA_REQUEST";
export const FETCH_ASSOCIATED_PARTIES_DATA_SUCCESS="FETCH_ASSOCIATED_PARTIES_DATA_SUCCESS";

export const UPDATE_ASSOCIATED_PARTIES_DATA_REQUEST="UPDATE_ASSOCIATED_PARTIES_DATA_REQUEST";
export const UPDATE_ASSOCIATED_PARTIES_DATA_SUCCESS="UPDATE_ASSOCIATED_PARTIES_DATA_SUCCESS";

export const UPDATE_CONTACT_RELATIONSHIP_REQUEST="UPDATE_CONTACT_RELATIONSHIP_REQUEST";

export const RESET_ASSOCIATED_PARTIES="RESET_ASSOCIATED_PARTIES";
export const FETCH_CREATE_PARTY_DATA_REQUEST = "FETCH_CREATE_PARTY_DATA_REQUEST";
export const FETCH_CREATE_PARTY_DATA_SUCCESS = "FETCH_CREATE_PARTY_DATA_SUCCESS";

export const FETCH_PARTY_INFO_REQUEST="FETCH_PARTY_INFO_REQUEST";
export const FETCH_PARTY_INFO_SUCCESS="FETCH_PARTY_INFO_SUCCESS";
export const FETCH_PARTY_SUGGESTION_REQUEST="FETCH_PARTY_SUGGESTION_REQUEST";
export const FETCH_PARTY_SUGGESTION_SUCCESS="FETCH_PARTY_SUGGESTION_SUCCESS";

export const ADD_ASSOCIATE_PARTY_REQUEST="ASSOCIATE_PARTY_REQUEST";
export const ADD_ASSOCIATE_PARTY_ERROR="ADD_ASSOCIATE_PARTY_ERROR";

export const DELETE_ASSOCIATE_PARTY_REQUEST="DELETE_ASSOCIATE_PARTY_REQUEST";
export const DELETE_ASSOCIATE_PARTY_SUCCESS="DELETE_ASSOCIATE_PARTY_SUCCESS";

export const CHANGE_LOG_ASSOCIATE_PARTY_REQUEST="CHANGE_LOG_ASSOCIATE_PARTY_REQUEST";
export const CHANGE_LOG_ASSOCIATE_PARTY_SUCCESS="CHANGE_LOG_ASSOCIATE_PARTY_SUCCESS";

export const SAVE_ASSOCIATED_PARTY = "SAVE_ASSOCIATED_PARTY";

export const RESET_PARTY_SUGGESTIONS = "RESET_PARTY_SUGGESTIONS";
export const EDIT_PARTY_REQUEST = "EDIT_PARTY_REQUEST";
export const EDIT_PARTY_SUCCESS = "EDIT_PARTY_SUCCESS";
export const RESET_EDIT_PARTY_DATA = "RESET_EDIT_PARTY_DATA";
export const SET_PARTY_ASSOCIATION = "SET_PARTY_ASSOCIATION";

export const SHOW_PARTIES_LOADER="SHOW_PARTIES_LOADER";
export const HIDE_PARTIES_LOADER="HIDE_PARTIES_LOADER";

export const FETCH_PARTY_STATES_REQUEST="FETCH_PARTY_STATES_REQUEST";
export const FETCH_PARTY_STATES_SUCCESS="FETCH_PARTY_STATES_SUCCESS";

export const FETCH_CARRIER_LIST = "FETCH_CARRIER_LIST"
export const FETCH_CARRIER_LIST_SUCCESS = "FETCH_CARRIER_LIST_SUCCESS"
